export default __webpack_public_path__ + "static/media/indexx grey.438c3bb4.svg";